import React from 'react';

import CollapsedDate from '../__collapsed/assignment__collapsed_date';

interface Props {
    assignDateValue: Date | null;
    deadlineDateValue: Date | null;
}

export const AssignmentDatePlaceholder = React.memo((props: Props) => {
    const { assignDateValue, deadlineDateValue } = props;

    if (!assignDateValue && !deadlineDateValue) {
        return null;
    }

    return <CollapsedDate />;
});
